import createSvgIcon from '@material-ui/core/utils/createSvgIcon';

const UserCircle = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M 19.5999 9.99999 C 19.5999 12.5461 18.5885 14.9879 16.7881 16.7882 C 14.9878 18.5886 12.546 19.6 9.9999 19.6 C 7.45382 19.6 5.01203 18.5886 3.21168 16.7882 C 1.41133 14.9879 0.399902 12.5461 0.399902 9.99999 C 0.399902 7.45392 1.41133 5.01212 3.21168 3.21177 C 5.01203 1.41142 7.45382 0.399994 9.9999 0.399994 C 12.546 0.399994 14.9878 1.41142 16.7881 3.21177 C 18.5885 5.01212 19.5999 7.45392 19.5999 9.99999 Z M 12.3999 6.39999 C 12.3999 7.03651 12.147 7.64696 11.697 8.09705 C 11.2469 8.54714 10.6364 8.79999 9.9999 8.79999 C 9.36338 8.79999 8.75293 8.54714 8.30285 8.09705 C 7.85276 7.64696 7.5999 7.03651 7.5999 6.39999 C 7.5999 5.76347 7.85276 5.15302 8.30285 4.70294 C 8.75293 4.25285 9.36338 3.99999 9.9999 3.99999 C 10.6364 3.99999 11.2469 4.25285 11.697 4.70294 C 12.147 5.15302 12.3999 5.76347 12.3999 6.39999 Z M 9.9999 11.2 C 8.85102 11.1998 7.72623 11.5294 6.7592 12.1497 C 5.79217 12.77 5.02355 13.6549 4.5447 14.6992 C 5.21991 15.4847 6.05703 16.1149 6.99864 16.5466 C 7.94024 16.9782 8.96407 17.2011 9.9999 17.2 C 11.0357 17.2011 12.0596 16.9782 13.0012 16.5466 C 13.9428 16.1149 14.7799 15.4847 15.4551 14.6992 C 14.9762 13.6549 14.2076 12.77 13.2406 12.1497 C 12.2736 11.5294 11.1488 11.1998 9.9999 11.2 Z"
      clipRule="evenodd"
    />
  </svg>,
  'UserCircle'
);

export default UserCircle;
